import "@aws-amplify/ui-react/styles.css";
import { LoginPage } from "components/Parts/Organisms/LoginPage";
import React from "react";

export const Login = React.memo(() => <LoginPage />);
